<template>
  <a-divider>
    <a-tooltip :title="!STATE ? '给无归属列表添加标签' :'取消添加标签'" @click="addTags" color="#2db7f5">
      <a-button type="primary" shape="circle" :size="size">
        <template #icon>
          <plus-circle-outlined v-if="!STATE"/>
          <close-circle-outlined v-else/>
        </template>
      </a-button>
    </a-tooltip>
    无归属列表
    <a-tooltip title="刷新无归属列表" color="#2db7f5">
      <a-button type="primary" @click="initList" shape="circle" :size="size">
        <template #icon>
          <RedoOutlined/>
        </template>
      </a-button>
    </a-tooltip>
  </a-divider>
  <a-card v-if="STATE" style="width: 100%;margin-bottom: 15px">
    <a-space wrap align="center">
      <a-tag @click="addInBulk(item)" style="cursor: pointer" :color="randomHexColor()"
             v-for="(item,index) in tag.tagListInfo" :key="index">
        {{ item.tagName }}
        <plus-outlined/>
      </a-tag>
      <a-input
          v-if="inputVisible"
          ref="inputRef"
          v-model:value="newTagName"
          type="text"
          size="small"
          :style="{ width: '78px' }"
          @blur="handleInputConfirm"
      />
      <a-tag v-else style="background: #fff; border-style: dashed" @click="showInput">
        <plus-outlined/>
        New Tag
      </a-tag>
    </a-space>
  </a-card>
  <a-checkbox
      v-if="STATE"
      v-model:checked="checkAll"
      :indeterminate="indeterminate"
      @change="onCheckAllChange"
      style="margin-left: 15px;"
  >
    全选
  </a-checkbox>
  <a-collapse
      v-model:activeKey="activeKey"
      :bordered="false"
      style="background: hsl(180deg, 23%, 97%)"
  >
    <template #expandIcon="{ isActive }">
      <caret-right-outlined :rotate="isActive ? 90 : 0"/>
    </template>
    <a-collapse-panel key="1" header="无归属设备列表" style="border: none">
      <template #extra>
        总数:{{ noTagList.length }}
      </template>
      <a-descriptions v-if="noTagList.length && !STATE" :column="3">
        <a-descriptions-item v-for="(item,index) in noTagList" :key="index">
          <a-space @click="single.changeCurrentCode(item, showArr,'nolist')"
                   :style="single.currentCode.qrCode === item ? 'background:pink' :''">
            <span style="color: #70b1e3;cursor: pointer">{{ item }}</span>
          </a-space>
        </a-descriptions-item>
      </a-descriptions>
      <template v-else-if="noTagList.length && STATE">
        <a-checkbox-group v-model:value="addList" style="width: 100%">
          <a-row>
            <a-col style="margin-bottom: 16px;font-weight: bold" :span="8" v-for="(item,index) in noTagList"
                   :key="index">
              <a-checkbox :value="item"><span style="color: #70b1e3">{{ item }}</span></a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </template>
      <a-empty :image="simpleImage" v-else/>
    </a-collapse-panel>
  </a-collapse>
</template>
<script setup>
import {
  CaretRightOutlined,
  PlusCircleOutlined,
  RedoOutlined,
  CloseCircleOutlined,
  PlusOutlined
} from "@ant-design/icons-vue";
import index from "@/layouts/admin-sidebar/tag/noTagList/index.js"
import {ref} from "vue";
import {Empty} from "ant-design-vue";
import tagList from "@/layouts/admin-sidebar/tag/list/tagList";
import tagStore from "@/stores/tagStore";
import singleDev from "@/stores/singleDev";

let single = singleDev();
let tag = tagStore();

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
let size = ref('small');

let {
  randomHexColor
} = tagList();

let {
  noTagList,
  initList,
  addTags,
  STATE,
  addList,
  indeterminate,
  checkAll,
  onCheckAllChange,
  addInBulk,
  handleInputConfirm,
  newTagName,
  inputVisible,
  showInput,
  inputRef,
  showArr
} = index();

let activeKey = ref("1")
</script>

<style scoped lang="scss">

</style>
